
      import Plus from './plus.vue'
      import type { App, Plugin } from 'vue'

      export const PlusPlugin: Plugin = {
        install(app: App) {
          app.component('Plus', Plus)
        },
      }
      export { Plus }
      